import { useMemo } from "react";
import UAParser from "ua-parser-js";

export const useDeviceDetect = () => {
  const deviceInfo = useMemo(() => {
    const userAgent =
      typeof navigator === "object" && "userAgent" in navigator ? navigator.userAgent : "";
    const parser = new UAParser(userAgent);

    return {
      isAndroid: parser.getOS().name === "Android",
      isFirefox: parser.getBrowser().name === "Firefox",
      isIOS: parser.getOS().name === "iOS",
      isMobile: parser.getDevice().type === UAParser.DEVICE.MOBILE,
    };
  }, []);
  return deviceInfo;
};
